import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors, Typography } from '@opallabs/gem'

export const cardList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: `${Spacing.M}px`,
  listStyle: 'none',
  margin: 0,
  padding: 0,
})

// Stacked rather than side-by-side: the settings modal's panes are narrow, and
// a button beside the body squeezes the description and status into ~230px.
export const card = css({
  alignItems: 'flex-start',
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: `${Spacing.M}px`,
  padding: `${Spacing.L}px`,
})

export const cardBody = css({
  display: 'flex',
  flexDirection: 'column',
  gap: `${Spacing.XS}px`,
})

export const cardTitleRow = css({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: `${Spacing.S}px`,
})

export const cardName = css({
  ...Typography.H300,
  color: gemVar(ThemedColors.TextPrimary),
  margin: 0,
})

export const cardDescription = css({
  ...Typography.T500,
  color: gemVar(ThemedColors.TextSecondary),
  margin: 0,
})
